<!--
 * @Description: 富友银行
 * @Date: 2025-05-20 18:00:29
-->
<template>
  <div class="account-info__items">
    <BaseTextTitle class="account-info__items__title">
      富友支付开户银行
    </BaseTextTitle>
    <BaseTextContent
      style="display: flex; flex-direction: column; padding-top: 0"
    >
      <div style="display: flex; width: 100%">
        <div style="margin: 5px 16px 0 0">
          <span style="color: red">*</span>
          请选择开户银行
        </div>
        <BaseFormItem
          prop="fyChannel"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
          style="margin-bottom: 0"
        >
          <BaseRadioGroup v-model="formData.fyChannel">
            <BaseRadio
              v-for="item in FY_CHANNEL"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </BaseRadio>
          </BaseRadioGroup>
        </BaseFormItem>
      </div>
      <div>预计开户时间：{{ tipsDay }}个工作日，实际以银行审核结果为准</div>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import { computed, watchEffect } from 'vue';
import {
  BaseFormItem,
  BaseRadio,
  BaseRadioGroup,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { FY_CHANNEL } from '../../constants';
import infoStore from '../../store/info';
import { storeToRefs } from 'pinia';

const { formData } = storeToRefs(infoStore());

const tipsDay = computed(() => {
  return formData.value.fyChannel === '01' ? '1' : '1-2';
});

watchEffect(() => {
  if (formData.value.fyChannel !== '01') {
    !formData.value.fyBeneficiaryInfoList.length &&
      (formData.value.fyBeneficiaryInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          address: null,
          portraitFilePath: null,
          badgeFilePath: null,
          beneficiaryType: null
        }
      ]);
    !formData.value.fyShareholderInfoList.length &&
      (formData.value.fyShareholderInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          portraitFilePath: null,
          badgeFilePath: null
        }
      ]);
  } else {
    formData.value.fyBeneficiaryInfoList = [];
    formData.value.fyShareholderInfoList = [];
  }
});
</script>
